var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property } from '@syncfusion/ej2-base';
import { DEFAULT_AI_COMMANDS } from './items';
/**
 * Configures AI Assistant functionality for the Rich Text Editor component.
 * This class provides options to customize the appearance, behavior, and content of the AI Assistant feature.
 */
export class AIAssistantSettings extends ChildProperty {
}
__decorate([
    Property(DEFAULT_AI_COMMANDS)
], AIAssistantSettings.prototype, "commands", void 0);
__decorate([
    Property('400px')
], AIAssistantSettings.prototype, "popupMaxHeight", void 0);
__decorate([
    Property('600px')
], AIAssistantSettings.prototype, "popupWidth", void 0);
__decorate([
    Property('Ask AI to rewrite or generate content.')
], AIAssistantSettings.prototype, "placeholder", void 0);
__decorate([
    Property(['AIcommands', 'Close'])
], AIAssistantSettings.prototype, "headerToolbarSettings", void 0);
__decorate([
    Property(['Edit', 'Copy'])
], AIAssistantSettings.prototype, "promptToolbarSettings", void 0);
__decorate([
    Property(['Regenerate', 'Copy', '|', 'Insert'])
], AIAssistantSettings.prototype, "responseToolbarSettings", void 0);
__decorate([
    Property([])
], AIAssistantSettings.prototype, "prompts", void 0);
__decorate([
    Property([])
], AIAssistantSettings.prototype, "suggestions", void 0);
__decorate([
    Property('')
], AIAssistantSettings.prototype, "bannerTemplate", void 0);
__decorate([
    Property(20)
], AIAssistantSettings.prototype, "maxPromptHistory", void 0);
